import { useEffect, useState } from "react";
import { useAuth } from "@/src/core/auth/useAuth";
import { refreshProfile } from "@/src/core/auth/api";
import { paymentService } from "@/src/shared/features/payment/services";
import type {
  IPaymentGatewayChoice,
  PaymentGateway,
} from "@/src/shared/features/payment/types";

/**
 * The app's `PaymentGatewaySelection`: re-reads the profile, defaults to a saved bKash number
 * until the guest picks a method, and saves a new bKash number unless the box is unticked.
 */
export const usePaymentGateway = (enabled: boolean): IPaymentGatewayChoice => {
  const { user_profile } = useAuth();
  const savedBkashNumber = String(user_profile?.bkash_msisdn ?? "");
  const hasSavedBkash = savedBkashNumber.length > 0;
  const [chosen, setChosen] = useState<PaymentGateway | null>(null);
  const [saveBkash, setSaveBkash] = useState(true);
  const gateway: PaymentGateway =
    chosen ?? (hasSavedBkash ? "savedBkash" : "bkash");

  useEffect(() => {
    if (enabled) void refreshProfile();
  }, [enabled]);

  return {
    gateway,
    select: setChosen,
    savedBkashNumber,
    hasSavedBkash,
    saveBkash,
    toggleSaveBkash: () => setSaveBkash((value) => !value),
    request: (isPaidByWalletOnly = false) =>
      paymentService.gatewayRequest(gateway, saveBkash, isPaidByWalletOnly),
  };
};
